import React from "react";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { createStore, combineReducers, applyMiddleware, compose } from "redux";
import thunk from "redux-thunk";
import ReactDOM from "react-dom/client";
import "react-app-polyfill/stable";
import "core-js";

import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { PermifyProvider } from "@permify/react-role";
import authReducer from "./store/reducers/auth";
import siteReducer from "./store/reducers/site";
import userReducer from "./store/reducers/user";
import faqReducer from "./store/reducers/faq";
import { eventReducer } from "./store/reducers/event";
import fundReducer from "./store/reducers/fund";
import groupReducer from "./store/reducers/group";
import transactionReducer from "./store/reducers/transaction";
import transactionReconciledReducer from "./store/reducers/transactionReconciled";
import digitalLibraryReducer from "./store/reducers/digital_library";
import replayReducer from "./store/reducers/replay";
import roleReducer from "./store/reducers/role";
import userRequestReducer from "./store/reducers/userRequest";
import editprofileReducer from "./store/reducers/editprofile";
import { logReducer } from "./store/reducers/log";
import Billreducer from "./store/reducers/bill";
import Queryreducer from "./store/reducers/query";
import { transactionApi } from "./store/querys/transactionApi";
import { billApi } from "./store/querys/billApi";

import { SocketProvider } from "./SocketContex";
import { userApi } from "./store/querys/userApi";
 import { spendApi } from "./store/querys/spendMonenyApi";
import { settingsApi } from "./store/querys/settingsApi";
import { roleApi } from "./store/querys/roleApi";
import { userListApi } from "./store/querys/userListApi";

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const rootReducer = combineReducers({
  auth: authReducer,
  site: siteReducer,
  user: userReducer,
  faq: faqReducer,
  event: eventReducer,
  fund: fundReducer,
  group: groupReducer,
  digitalLibrary: digitalLibraryReducer,
  transaction: transactionReducer,
  transactionReconciled: transactionReconciledReducer,
  replay: replayReducer,
  role: roleReducer,
  log: logReducer,
  bill: Billreducer,
  query: Queryreducer,
  userRequest: userRequestReducer,
  editprofile: editprofileReducer,
  

  [billApi.reducerPath]: billApi.reducer,
  [transactionApi.reducerPath]: transactionApi.reducer,
  [userApi.reducerPath]: userApi.reducer,
  [spendApi.reducerPath]: spendApi.reducer,
  [settingsApi.reducerPath]: settingsApi.reducer,
  [roleApi.reducerPath]: roleApi.reducer,
  [userListApi.reducerPath]: userListApi.reducer,





  
});

export const store = createStore(
  rootReducer,
  composeEnhancers(
    applyMiddleware(
      thunk,
      transactionApi.middleware,
      billApi.middleware,
      userApi.middleware,
      spendApi.middleware,
      settingsApi.middleware,
       roleApi.middleware,
       userListApi.middleware,

    ),
  ),
);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  <PermifyProvider>
    <Provider store={store}>
      <SocketProvider>
        <BrowserRouter >
          <App />
        </BrowserRouter>
      </SocketProvider>
    </Provider>
  </PermifyProvider>,
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();